import { AVAILABLE_LEARNING_LANGUAGES } from './learningLanguages';

export const UI_LANGUAGE_STORAGE_KEY = 'aprendos_language';
export const DEFAULT_UI_LANGUAGE_CODE = 'en';
export const UI_LANGUAGE_FOLLOWS_LEARNING_STORAGE_KEY = 'aprendos_ui_language_follows_learning';

export const UI_LANGUAGES = [
  { code: 'en', shortName: 'EN', nativeName: 'English' },
  { code: 'es', shortName: 'ES', nativeName: 'Español' },
  { code: 'no', shortName: 'NO', nativeName: 'Norsk (Bokmål)' },
  { code: 'de', shortName: 'DE', nativeName: 'Deutsch' },
  { code: 'fr', shortName: 'FR', nativeName: 'Français' },
  { code: 'pt', shortName: 'PT', nativeName: 'Português' },
  { code: 'it', shortName: 'IT', nativeName: 'Italiano' },
  { code: 'ru', shortName: 'RU', nativeName: 'Русский' },
  { code: 'nl', shortName: 'NL', nativeName: 'Nederlands' },
  { code: 'pl', shortName: 'PL', nativeName: 'Polski' },
  { code: 'tr', shortName: 'TR', nativeName: 'Türkçe' },
  { code: 'zh-CN', shortName: 'CN', nativeName: '中文' },
  { code: 'ja', shortName: 'JP', nativeName: '日本語' },
  { code: 'ar', shortName: 'AR', nativeName: 'العربية' },
];

export const SUPPORTED_UI_LANGUAGE_CODES = UI_LANGUAGES.map((language) => language.code);
export const SELECTABLE_UI_LANGUAGE_CODES = AVAILABLE_LEARNING_LANGUAGES
  .map((language) => language.code)
  .filter((code, index, allCodes) => allCodes.indexOf(code) === index)
  .filter((code) => SUPPORTED_UI_LANGUAGE_CODES.includes(code));

export const SELECTABLE_UI_LANGUAGES = UI_LANGUAGES.filter((language) =>
  SELECTABLE_UI_LANGUAGE_CODES.includes(language.code)
);

export function normalizeUiLanguageCode(input, fallbackCode = DEFAULT_UI_LANGUAGE_CODE) {
  const raw = String(input || '').trim().toLowerCase();
  if (!raw) return fallbackCode;

  if (raw.startsWith('nb') || raw.startsWith('nn') || raw.startsWith('no')) return 'no';
  if (raw.startsWith('zh')) return 'zh-CN';

  const direct = UI_LANGUAGES.find((language) => language.code.toLowerCase() === raw);
  if (direct) return direct.code;

  const base = raw.split('-')[0];
  const baseMatch = UI_LANGUAGES.find((language) => language.code.toLowerCase() === base);
  if (baseMatch) return baseMatch.code;

  return fallbackCode;
}

export function getUiLanguage(code) {
  const normalizedCode = normalizeUiLanguageCode(code);
  return UI_LANGUAGES.find((language) => language.code === normalizedCode) || UI_LANGUAGES[0];
}

export function isSelectableUiLanguageCode(code) {
  return SELECTABLE_UI_LANGUAGE_CODES.includes(normalizeUiLanguageCode(code));
}

export function shouldUiLanguageFollowLearningLanguage() {
  try {
    return localStorage.getItem(UI_LANGUAGE_FOLLOWS_LEARNING_STORAGE_KEY) !== 'false';
  } catch {
    return true;
  }
}

export function setUiLanguageFollowsLearningLanguage(shouldFollow) {
  try {
    localStorage.setItem(UI_LANGUAGE_FOLLOWS_LEARNING_STORAGE_KEY, shouldFollow ? 'true' : 'false');
  } catch {
    // Ignore storage failures; the current session can still proceed.
  }
}
